module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1200-a59571ada3c41e231bd1979217277f12.webp";